var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("\n                " + _vm._s(_vm.show.title) + " "), _c('br'), _c('div', {
    staticClass: "btn"
  }, [_vm._v("\n                  Рейтинг "), _c('span', {
    staticClass: "badge badge-secondary"
  }, [_vm._v("\n                      " + _vm._s(_vm.show.rating * 2) + " из 10\n                  ")])])]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "src": _vm.getImg
    }
  })]), _vm._v(" "), _c("router-link", {
    tag: "a",
    staticClass: "btn btn-primary",
    attrs: {
      "to": '/detail/' + _vm.show.id
    }
  }, [_vm._v("Подробнее")])])]), _vm._v(" "), _c('br')])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6798e686","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comp/ShowListItem.vue
// module id = Q7e/
// module chunks = 0